import { useLang } from '@/i18n';
import EfImg from '@elem/ui/ef-img';
import EfTitle from '@elem/ui/ef-title';
import classNames from 'classnames';
import EfSpec from 'elem/ui/ef-spec';
import { IMG_R3_MAX, IMG_R3_MAX_PLUS, IMG_R3_PLUS } from '../utils';
import BlueTag from './BlueTag';
import styles from './Compare.module.scss';
import GoldTag from './GoldTag';
import GrayTag from './GrayTag';
// import './index.scss';

// 参数转换
const getListHandle = (items: any[]) => {
    const length = items.length;
    const resultC: any = [];
    const specListAll = [];
    let specListLength = 0;

    const itemB1 = []; // 保存header
    for (let i = 0; i < length; i++) {
        const itemA1 = items[i]; // 来源处
        itemB1.push({
            isHead: true,
            pc: itemA1.pc,
            h5: itemA1.h5,
            title: itemA1.title,
            desc: itemA1.desc,
        });

        const specList = itemA1.specList || [];
        specListLength = specList.length;
        specListAll.push(...specList);
    }
    resultC.push(itemB1); //保存header
    for (let m = 0; m < specListLength; m++) {
        const itemB2 = []; // 保存值
        for (let n = 0; n < length; n++) {
            const itemA2 = specListAll[m + n * specListLength];
            itemB2.push({
                title: itemA2.title,
                desc: itemA2.desc,
            });
        }
        resultC.push(itemB2); //保存第i列的数据
    }

    return resultC;
};

export default function Compare() {
    const { t } = useLang('theProduct.TabA');
    const listA = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724578776173/dd1.png',
        title: t('win3_a_title'),
        desc: t('win3_a_desc'),
        specList: [
            {
                title: t('win3_a_item1_t'),
                desc: t('win3_a_item1_b'),
            },
            {
                title: t('win3_a_item2_t'),
                desc: t('win3_a_item2_b'),
            },
            {
                title: t('win3_a_item3_t'),
                desc: t('win3_a_item3_b'),
            },
            {
                title: t('win3_a_item4_t'),
                desc: t('win3_a_item4_b'),
            },
            {
                title: t('win3_a_item5_t'),
                desc: t('win3_a_item5_b'),
            },
            {
                title: t('win3_a_item6_t'),
                desc: t('win3_a_item6_b'),
            },
            {
                title: t('win3_a_item7_t'),
                desc: t('win3_a_item7_b'),
            },
            {
                title: t('win3_a_item8_t'),
                desc: t('win3_a_item8_b'),
            },
            {
                title: t('win3_a_item9_t'),
                desc: t('win3_a_item9_b'),
            },
        ],
    };

    const listB = {
        pc: IMG_R3_PLUS,
        h5: '',
        title: t('win3_b_title'),
        desc: t('win3_b_desc'),
        specList: [
            {
                title: t('win3_b_item1_t'),
                desc: t('win3_b_item1_b'),
            },
            {
                title: t('win3_b_item2_t'),
                desc: t('win3_b_item2_b'),
            },
            {
                title: t('win3_b_item3_t'),
                desc: t('win3_b_item3_b'),
            },
            {
                title: t('win3_b_item4_t'),
                desc: t('win3_b_item4_b'),
            },
            {
                title: t('win3_b_item5_t'),
                desc: t('win3_b_item5_b'),
            },
            {
                title: t('win3_b_item6_t'),
                desc: t('win3_b_item6_b'),
            },
            {
                title: t('win3_b_item7_t'),
                desc: t('win3_b_item7_b'),
            },
            {
                title: t('win3_b_item8_t'),
                desc: t('win3_b_item8_b'),
            },
            {
                title: t('win3_b_item9_t'),
                desc: t('win3_b_item9_b'),
            },
        ],
    };

    const listC = {
        pc: IMG_R3_MAX,
        h5: '',
        title: t('win3_c_title'),
        desc: t('win3_c_desc'),
        specList: [
            {
                title: t('win3_c_item1_t'),
                desc: t('win3_c_item1_b'),
            },
            {
                title: t('win3_c_item2_t'),
                desc: t('win3_c_item2_b'),
            },
            {
                title: t('win3_c_item3_t'),
                desc: t('win3_c_item3_b'),
            },
            {
                title: t('win3_c_item4_t'),
                desc: t('win3_c_item4_b'),
            },
            {
                title: t('win3_c_item5_t'),
                desc: t('win3_c_item5_b'),
            },
            {
                title: t('win3_c_item6_t'),
                desc: t('win3_c_item6_b'),
            },
            {
                title: t('win3_c_item7_t'),
                desc: t('win3_c_item7_b'),
            },
            {
                title: t('win3_c_item8_t'),
                desc: t('win3_c_item8_b'),
            },
            {
                title: t('win3_c_item9_t'),
                desc: t('win3_c_item9_b'),
            },
        ],
    };

    const listD = {
        pc: IMG_R3_MAX_PLUS,
        h5: '',
        title: t('win3_d_title'),
        desc: t('win3_d_desc'),
        specList: [
            {
                title: t('win3_d_item1_t'),
                desc: t('win3_d_item1_b'),
            },
            {
                title: t('win3_d_item2_t'),
                desc: t('win3_d_item2_b'),
            },
            {
                title: t('win3_d_item3_t'),
                desc: t('win3_d_item3_b'),
            },
            {
                title: t('win3_d_item4_t'),
                desc: t('win3_d_item4_b'),
            },
            {
                title: t('win3_d_item5_t'),
                desc: t('win3_d_item5_b'),
            },
            {
                title: t('win3_d_item6_t'),
                desc: t('win3_d_item6_b'),
            },
            {
                title: t('win3_d_item7_t'),
                desc: t('win3_d_item7_b'),
            },
            {
                title: t('win3_d_item8_t'),
                desc: t('win3_d_item8_b'),
            },
            {
                title: t('win3_d_item9_t'),
                desc: t('win3_d_item9_b'),
            },
        ],
    };

    const prefixCls = `ef-product-compare-c`;
    const classes = classNames(prefixCls, 'ef-container', {
        [`${prefixCls}-bg1`]: 'bg1',
    });

    const listAll = [listA, listB, listC, listD];
    const items2 = getListHandle(listAll);
    console.log({ listAll, items2 });
    return (
        <div className={styles.Win3}>
            <EfSpec className="spec-x" />
            <EfTitle hasAnimation={false}>{t('win3_title')}</EfTitle>
            <div className={classes}>
                <div className={`${prefixCls}-table`}>
                    {items2.map((item1: any, index1: number) => {
                        return (
                            <div className={`${prefixCls}-tr ${prefixCls}-tr-${index1 + 1}${index1 === 0 ? ` ${prefixCls}-tr-head` : ''}`} key={index1}>
                                {item1?.map((item2: any, index2: number) => {
                                    const isHighlight = [7, 8].includes(index1) && [1, 2, 3].includes(index2);
                                    const grayBg = [0].includes(index2);
                                    return (
                                        <div
                                            className={`${prefixCls}-td ${prefixCls}-td1 ${` ${prefixCls}-td-${index2 + 1}`}${
                                                item2.isHead ? ` ${prefixCls}-td-head` : ''
                                            }${isHighlight ? ' highlight-cell' : ''}${grayBg ? ' gray-bg' : ''}`}
                                            key={index2}
                                        >
                                            <div className={`${prefixCls}-td-in1`}>
                                                {item2.pc && (
                                                    <>
                                                        <div className={`${prefixCls}-item-img1`}>
                                                            <EfImg pc={item2.pc} />
                                                        </div>
                                                        {index2 === 0 && (
                                                            <div className="tag-container">
                                                                <BlueTag style={{ opacity: 0 }} />
                                                            </div>
                                                        )}
                                                        {index2 === 1 && (
                                                            <div className="tag-container">
                                                                <BlueTag />
                                                            </div>
                                                        )}
                                                        {index2 === 2 && (
                                                            <div className="tag-container">
                                                                <GrayTag />
                                                            </div>
                                                        )}
                                                        {index2 === 3 && (
                                                            <div className="tag-container">
                                                                <GoldTag />
                                                            </div>
                                                        )}
                                                    </>
                                                )}
                                                <div className={`${prefixCls}-item-info`}>
                                                    <div className={`${prefixCls}-item-title`}>{item2.title}</div>
                                                    <div className={`${prefixCls}-item-desc`}>{item2.desc}</div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
